"use client";

import React, { useState } from "react";
import "./First_Curriculum.css";
import CommonHeading from "../../common-component/common-heading/CommonHeading";

const expertiseData = [
  {
    id: 1,
    title: "Co-Created with Industry Experts",
    description:
      "Designed alongside practitioners to reflect real business challenges and emerging trends.",
    image: "/assets/images/img_1.webp",
  },
  {
    id: 2,
    title: "Blending Academic & Industry Expertise",
    description:
      "Combining strong academic foundations with practical insights from industry professionals.",
    image: "/assets/images/img_2.webp",
  },
  {
    id: 3,
    title: "AI Embedded Across Learning",
    description:
      "AI-powered learning experiences designed to prepare professionals for the future.",
    image: "/assets/images/img_3.webp",
  },
  {
    id: 4,
    title: "Continuously Updated Curriculum",
    description:
      "Our curriculum evolves continuously to stay aligned with changing industry requirements.",
    image: "/assets/images/img_4.webp",
  },
];

const First_Curriculum = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const activeItem = expertiseData[activeIndex];

  return (
    <section className="industry_expertise_section">
      <div className="container">
        <CommonHeading
          subTitle={"Industry-Integrated,"}
          title={"AI-First Curriculum"}
          description={
            "At ATLAS SkillTech University, the curriculum is designed to stay aligned with the real world. India's first AI-native corporate Online MBA features a first-of-its-kind 3-in-1 credential, combining an industry-led MBA with the Builder Score and Human Edge Index to prepare future-ready leaders."
          }
        />

        <div className="industry_expertise_container">
          {/* LEFT CONTENT */}
          <div className="industry_expertise_left">
            {expertiseData.map((item, index) => {
              const isActive = activeIndex === index;

              return (
                <div
                  key={item.id}
                  className={`expertise_item ${isActive ? "active" : ""}`}
                  onClick={() => setActiveIndex(index)}
                >
                  <div className="expertise_content">
                    <h3>{item.title}</h3>

                    {isActive && (
                      <p className="expertise_description">
                        {item.description}
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          {/* RIGHT IMAGE */}
          <div className="industry_expertise_right">
            <div className="expertise_image_wrapper" key={activeItem.id}>
              <img
                src={activeItem.image}
                alt={activeItem.title}
                className="expertise_image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default First_Curriculum;
